import * as types from "./authTypes";
const initialState={
    isAuth:false,
    token:"",
    isLoading:false,
    isError:false,
}

const reducer=(state=initialState,action)=>{
    const {type,payload}= action;
    switch(type){
        case types.REGISTER_REQUEST:
            return {
                ...state,
                isLoading:true,
            }
        case types.REGISTER_SUCCESS:
            return{
                ...state,
                isLoading:false,
                isError:false,
            }
        case types.REGISTER_FAILURE:
            return{
                ...state,
                isLoading:false,
                isError:true,
            }
            case types.LOGIN_REQUEST:
                return {
                    ...state,
                    isLoading:true,
                }
            case types.LOGIN_SUCCESS:
                return{
                    ...state,
                    isLoading:false,
                    token:payload,
                    isAuth:true,
                    isError:false,
                }
            case types.LOGIN_FAILURE:
                return{
                    ...state,
                    isLoading:false,
                    isError:true,
                    isAuth:false,
                    token:""
                }

        default:
            return state; 
    } 
}


export {reducer};